import { useFormContext } from 'react-hook-form'

export default function useFormMethodsWithLegacyFormSupport () {
    const context = useFormContext()

    if (context?.register) return context
    if (context?.formState) return context.formState?.methods
}